module.exports = __webpack_public_path__ + "assets/img/favicon-48x48.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon-48x48.ico
// module id = 1930
// module chunks = 0